import { Path } from "rot-js"
import { AIAction, EnemyType, ItemType } from "../../../defines/enums"
import { CombatConfig, Position, RenderConfig } from "../../../defines/types"
import { EnemyDefaults, PlayerDefaults } from "../../../defines/values"
import { Enemy } from "../enemy"
import { MobileEnemy } from "../mobile"

export class PathEnemy extends MobileEnemy {
  protected _dx: number
  protected _dy: number
  protected _fov: number
  protected _path: [number, number][]

  constructor(
    type: EnemyType,
    experience: number,
    combat: CombatConfig,
    position: Position,
    render: RenderConfig,
    name: string,
    fov: number,
    optic?: ItemType
  ) {
    super(type, experience, combat, position, render, name, optic)
    this._dx = 0
    this._dy = 0
    this._path = []

    if (fov !== undefined) {
      this._fov = fov
    } else {
      this._fov = EnemyDefaults.FOV
    }

    this._state = AIAction.WAITING
  }

  get fov(): number | undefined {
    return this._fov
  }

  getPathTo(x: number, y: number) {
    const isPassable = (x: number, y: number) => window.engine.inBounds(x, y)
    const dijkstra = new Path.Dijkstra(x, y, isPassable, {})

    this._path = []

    dijkstra.compute(
      this.position.x,
      this.position.y,
      (x: number, y: number) => {
        this._path.push([x, y])
      }
    )
    this._path.shift()
  }

  projectMove(): AIAction {
    this._state = AIAction.WAITING

    const player = window.engine.getPlayer()
    const targetX = player.position.x
    const targetY = player.position.y

    const dx = targetX - this.position.x
    const dy = targetY - this.position.y
    const distance = Math.max(Math.abs(dx), Math.abs(dy))

    if (
      distance <=
      this._fov - player.stealth * PlayerDefaults.STEALTH_MODIFIER
    ) {
      if (distance <= Enemy.ATTACK_RANGE) {
        // only allow attacks on the horz/vert
        if (this.position.x == targetX || this.position.y == targetY) {
          window.engine.processEnemyAttack(this, true)
          this._state = AIAction.ATTACKING
        }
      } else {
        this.getPathTo(targetX, targetY)
        this._path.pop()
      }
    }

    if (this._path.length > 0) {
      const [destX, destY] = this._path[0]
      this._path.shift()
      this.move(destX - this.position.x, destY - this.position.y)
      this._state = AIAction.MOVING
    }

    return this._state
  }

  move(x: number, y: number): void {
    const destX = this.position.x + x
    const destY = this.position.y + y

    if (!window.engine.inBounds(destX, destY)) return

    const e = window.engine.getEntitiesAtLocation({ x: destX, y: destY })

    if (e !== undefined && e.length > 0 && e[0].blocks) return

    this.position.x = destX
    this.position.y = destY
  }
}
